import DoneAllIcon from "@mui/icons-material/DoneAll";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";

import { useShipperShipmentPageContext } from "hooks";

interface Props {
  onOpenMarkAsDelivered: () => void;
}

export function MarkShipmentAsDeliveredMenuOption(props: Props) {
  const { onOpenMarkAsDelivered } = props;
  const { shipment } = useShipperShipmentPageContext();

  if (
    !shipment ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT" ||
    (shipment.shipment_status !== "BOOKED" &&
      shipment.shipment_status !== "PICKED_UP") ||
    (shipment.access_type !== "OWNER" && shipment.access_type !== "ADMIN")
  ) {
    return null;
  }

  return (
    <ListItem>
      <Tooltip
        followCursor
        title={
          <Typography variant="body1">
            Marks a shipment as delivered.
          </Typography>
        }
      >
        <ListItemButton onClick={onOpenMarkAsDelivered}>
          <ListItemIcon>
            <DoneAllIcon />
          </ListItemIcon>
          <ListItemText primary="Mark as delivered" />
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
}
